import BRAND_LOGO from '../../themes/ronin/brand_logo_home.gif';

const ronin = {
  application: 'Ronin',
  business: 'AOL',
  fullBusiness: 'Art of Logic',
  hmLink: 'https://ronin.artoflogic.ai',
  businessLink: 'https://www.artoflogic.ai',
  contactEmail: 'sales@artoflogic.ai',
  contactEmailSupport: 'support@artoflogic.ai',
  BRAND_LOGO: BRAND_LOGO,
};

export default ronin;
